import { useContext } from "react";
import Header from "../Components/Header/Header";
import PlanDetails from "../Components/PlanDetails/PlanDetails";
//  import TravellerPlanDetails from  "../Components/TravellerPlanDetails/TravellerPlanDetails";
import MyContext from "../Context/MainContext";

export const CommonLayout = ({ children }) => {
    const lang=sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en"
    const isArabicLang = lang === 'ar';
    const {contextValue } = useContext(MyContext);
    // console.log("contextValue",contextValue);
 
    return (
        <div className="main">
            <Header showLargeMenu={false} />
            <div className="innerbody-con">
                  { <PlanDetails 
                    products={contextValue.updatedPremiumDetails}
                    isArabicLang={isArabicLang}
                /> }
                {children}
            </div>
      </div>
    );
  };
